import { useState } from 'react';
import ChargerModule from '../../components/chargerModule';
import StockOrdersFilters from './components/NewStockOrdersFilters/StockOrdersFilters';
import BordOneToneIcon from '../../components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import StockOrdersList from './components/StockOrdersList/StockOrdersList';
import useStockOrdersModuleState from '../../state/useStockOrdersModuleState';
import CustomSelect from '../../components/customSelect';
import { STOCK_ORDER_PROPERTIES_TO_SEARCH, StockOrderPropertyToFilter } from '../../types/stockOrders';
import './StockOrdersModule.scss';
/** 
 * Vista principal para el listado de órdenes de stock
 */
const StockOrdersModule = () => {
  const { searchText, setSearchText, propertyToFilterSearch, setPropertyToFilterSearch } = useStockOrdersModuleState();
  const [loadingSearchBar] = useState(false);

  const handleSetPropertyToFilterSearch = (value: STOCK_ORDER_PROPERTIES_TO_SEARCH) => {
    const propertyMap: Record<STOCK_ORDER_PROPERTIES_TO_SEARCH, StockOrderPropertyToFilter> = {
      [STOCK_ORDER_PROPERTIES_TO_SEARCH.ORDER_ID]: 'orderId',
      [STOCK_ORDER_PROPERTIES_TO_SEARCH.INVOICE_NUMBER]: 'invoiceNumber',
      [STOCK_ORDER_PROPERTIES_TO_SEARCH.PROVIDER]: 'provider',
      [STOCK_ORDER_PROPERTIES_TO_SEARCH.SKU]: 'sku',
      [STOCK_ORDER_PROPERTIES_TO_SEARCH.SERIAL]: 'serial'
    };

    setPropertyToFilterSearch({
      name: value,
      propertyToFilter: propertyMap[value]
    });
    setSearchText('');
  };

  const getSearchbarPlaceholder = () => {
    if (!propertyToFilterSearch) return 'Selecciona un tipo de búsqueda';

    switch (propertyToFilterSearch.name) {
      case STOCK_ORDER_PROPERTIES_TO_SEARCH.ORDER_ID:
        return 'Busca por n° de orden';
      case STOCK_ORDER_PROPERTIES_TO_SEARCH.INVOICE_NUMBER:
        return 'Busca por n° de factura';
      case STOCK_ORDER_PROPERTIES_TO_SEARCH.PROVIDER:
        return 'Busca por proveedor';
      case STOCK_ORDER_PROPERTIES_TO_SEARCH.SKU:
        return 'Busca por SKU';
      case STOCK_ORDER_PROPERTIES_TO_SEARCH.SERIAL:
        return 'Busca por serial';
      default:
        return 'Selecciona un tipo de búsqueda';
    }
  };

  const headerInfo = {
    title: 'Órdenes stock',
    titleRoute: '/stock/list-stock',
    subtitle: 'Compras',
    searchbarPlaceholder: getSearchbarPlaceholder()
  };

  const buttons = [
    {
      title: 'Compra de stock',
      route: '/stock/create-new-order-stock',
      color: 'secondary',
      icon: (
        <div className="flex items-center justify-center">
          <BordOneToneIcon variant="shoppingCart" standardSize={10} />
        </div>
      ),
      customClassNameContainer: 'stockOrdersButtonCustomClassNameContainer',
      customClassName: 'stockOrdersModuleButton'
    }
  ];

  return (
    <div id="stockOrdersModule">
      <ChargerModule
        infoSideBar={{ position: 'stock' }}
        headerInfo={headerInfo}
        viewSearchBar
        searchText={searchText}
        setSearchText={propertyToFilterSearch ? setSearchText : () => {}}
        searchbarPlaceholder={headerInfo.searchbarPlaceholder}
        loadingSearchBar={loadingSearchBar}
        buttons={buttons}
        searchBarDropdownList={
          <div className="flex items-center">
            <CustomSelect
              dropdownLabel="Tipo de búsqueda"
              items={Object.values(STOCK_ORDER_PROPERTIES_TO_SEARCH)}
              value={propertyToFilterSearch?.name}
              onChangeSelect={value => handleSetPropertyToFilterSearch(value as STOCK_ORDER_PROPERTIES_TO_SEARCH)}
              defaultValue="Tipo de búsqueda"
            />
          </div>
        }
      >
        <div id="stockOrdersModuleContent">
          <StockOrdersFilters />
          <StockOrdersList />
        </div>
      </ChargerModule>
    </div>
  );
};

export default StockOrdersModule;
